<svelte:options customElement="hb-offcanvas" />

<script lang="ts">
  /**
   * Svelte Video Login/Register/Forget Password WebComponent
   * =====================
   *
   * @contributors: Dario Caruso <dev@dariocaruso.info> (https://dariocaruso.info)
   *
   * @license: MIT License
   *
   */

  import pkg from "../../../package.json";
  import type { INavLink } from "../sidenav-link/types/webcomponent.type";

  import type { Component } from "./types/webcomponent.type";
  import {
    addComponent,
    getChildStyleToPass,
    LanguageTranslator,
  } from "wc-js-utils";
  import parseStyle from "style-to-object";

  import { styleSetup as sidenavLinkStyleSetup } from "../sidenav-link/extra/docs";
  import { styleSetup as sidebarDesktopStyleSetup } from "../sidebar-desktop/extra/docs";

  import type { Events as SidebarDesktopEvents } from "../sidebar-desktop/types/webcomponent.type";

  let {
    id,
    // style = "",
    type = "autohide",
    navlinks = undefined,
    companylogouri = "",
    navpage = "home",
    groups = [],
    opened = false,
    companytitle = "",
    enablefooter = false,
  }: Component = $props();

  let parsedStyle: { [x: string]: string } = $state({});
  let sidenavLinkStyleToSet: string = $state("");
  let sidebarDesktopStyleToSet: string = $state("");
  let switched = $state(false);
  $effect(() => {
    // if (style) {
    //   parsedStyle = parseStyle(style) as any;
    //   sidenavLinkStyleToSet = getChildStyleToPass(
    //     parsedStyle,
    //     sidenavLinkStyleSetup?.vars
    //   );
    //   sidebarDesktopStyleToSet = getChildStyleToPass(
    //     parsedStyle,
    //     sidebarDesktopStyleSetup?.vars
    //   );
    // }

    if (!companytitle) companytitle = "";
    if (!enablefooter || (enablefooter as unknown as string) === "no")
      enablefooter = false;
    if (type === "open" || (opened && (opened as unknown as string) !== "no")) {
      opened = true;
      if (!switched)
        dispatch("offcanvasswitch", {
          isOpen: opened,
        });
      switched = true;
    } else {
      opened = false;
    }

    try {
      if (typeof groups === "string") {
        groups = JSON.parse(groups);
      }
    } catch (err) {}
  });

  function dispatch(name: string, detail: any) {
    $host().dispatchEvent(new CustomEvent(name, { detail }));
  }
  function changePage(page: string) {
    console.log(page);
    dispatch("pageChange", {
      page,
    });
    OpenSwitch(false);
  }
  function OpenSwitch(open: boolean) {
    opened = open;
    switched = false;

    dispatch("offcanvasswitch", {
      isOpen: opened,
    });
  }

  addComponent({
    repoName: "@htmlbricks/hb-sidenav-link",
    version: pkg.version,
  });
  addComponent({
    repoName: "@htmlbricks/hb-sidebar-desktop",
    version: pkg.version,
  });
</script>

<svelte:head>
  <link
    rel="stylesheet"
    href="https://cdn.jsdelivr.net/npm/bootstrap-icons@latest/font/bootstrap-icons.css"
  />
</svelte:head>
<div id="webcomponent">
  <slot name="test" />
  <div
    class="offcanvas offcanvas-start show"
    tabindex="-1"
    aria-labelledby="offcanvasExampleLabel"
    style="overflow-y: auto; visibility: visible; {opened
      ? 'transform:none!important'
      : 'transform:translateX(-100%)!important'};"
  >
    <hb-sidebar-desktop
      onpageChange={(e: { detail: SidebarDesktopEvents["pageChange"] }) =>
        dispatch("pageChange", e.detail)}
      style={sidebarDesktopStyleToSet}
      {navlinks}
      {navpage}
      {companytitle}
    ></hb-sidebar-desktop>
  </div>
  {#if type === "autohide"}
    <!-- svelte-ignore a11y_click_events_have_key_events -->
    <!-- svelte-ignore a11y_no_static_element_interactions -->
    <div
      onclick={() => OpenSwitch(false)}
      class="modal-backdrop fade {opened ? 'show' : ''}"
      style="z-index:1040; {opened ? '' : 'visibility:hidden'}"
    ></div>
  {/if}
</div>

<style lang="scss">
  @forward "./styles/bootstrap.scss";
  @forward "./styles/webcomponent.scss";

  i {
    min-width: 16px;
    display: inline-block;
  }
  .offcanvas-start {
    width: 240px;
  }
  .nav-link {
    padding: 0.5rem 0.2rem 0.5rem 0.2rem;
  }
  hb-sidebar-desktop {
    width: 100%;
  }
</style>
